import './dashboard-page.css';

import { useGetLatestIncidentsQuery } from '../../redux/api/incidents';

const DashboardPage = () => {

    const { data: incidents } = useGetLatestIncidentsQuery(null);

    return (
        <div className="dashboard-page-container">
            <h1>Dashboard</h1>
            <div className="dashboard-content">
                <div className="center-dashboard"></div>
                <div className="footer-dashboard">
                    <div className="widget-panel">
                        <div className="panel-header">Recent Incidents</div>
                        <div className="panel-content">
                            <div className="incident-list">
                                {incidents?.map((incident: any, index: number) => <div key={index} className="incident-item">
                                    <div className="incident-id">{incident.incidentId}</div>
                                    <div className="department-id">Dept ID: {incident.departmentId}</div>
                                    <div className="incident-date">{new Date(incident.createdAt + "Z").toLocaleString()}</div>
                                </div>)}
                            </div>
                        </div>
                        
                    </div>
                    <div className="widget-panel">
                    </div>
                </div>
            </div>
        </div>
    );
};
export default DashboardPage;

